// extracted by mini-css-extract-plugin
module.exports = {"mobile":"375","tablet":"768","desktop":"1280"};